
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { myStudyMenu } from '@xt/client/dataSource/my/index'
import { EnumMyStudyMenu, EnumMyCenterPrivacyConfig } from '@xt/client/enums/my'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import StudyCard from '../../../views/StudyCard/index.vue'
import { MomentSourceType } from '@xt/client/enums/moment'
import { Throttle, Bind } from 'lodash-decorators'
import lodash from 'lodash'

@Observer
@Component({
  components: {
    InfiniteLoading,
    EmptyStatus,
    StudyCard
  }
})
export default class ContentList extends Vue {
  @Prop({ required: true }) memberId: string

  current: EnumMyStudyMenu = EnumMyStudyMenu.Homework
  isScrolled: boolean = false

  get body() {
    return {
      memberId: this.memberId,
      sourceTypes: this.mapSourceTypes()
    }
  }

  get PageStore() {
    return this.$store.$myV2.Center
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get currentVisible() {
    return lodash.find(myStudyMenu, {
      value: this.current
    })!.visible
  }

  get filterLabels() {
    return myStudyMenu
  }

  @Throttle(100, { leading: true, trailing: true })
  @Bind()
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

    if (scrollTop > 0) {
      if (!this.isScrolled) {
        this.isScrolled = true
      }
    } else {
      this.isScrolled = false
    }
  }

  mapSourceTypes() {
    if (this.current === EnumMyStudyMenu.Reward) return MomentSourceType.Show

    if (this.current === EnumMyStudyMenu.Daily)
      return [
        MomentSourceType.ExhibitionDiary,
        MomentSourceType.ExhibitionTidbits,
        MomentSourceType.SunDrying,
        MomentSourceType.Guild
      ].join(',')

    return undefined
  }

  handleChange(value: EnumMyStudyMenu) {
    if (this.current === value) return

    this.current = value

    document.documentElement.scrollTo({ top: 0 })

    this.PageStore.handleChangeContentList(value)
  }

  init() {
    this.PageStore.handleChangeContentList(this.current)
  }

  created(): void {
    this.init()
  }

  mounted(): void {
    window.addEventListener('scroll', this.onScroll)
  }

  updated(): void {}

  destroyed(): void {
    window.removeEventListener('scroll', this.onScroll)
  }
}
